import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Box, Link, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//
import { StyledItem, StyledIcon } from "./styles";
import colors from "../../../config/colors";
import useActiveLink from "../../../hooks/useActiveLink";
import { useAuth } from "../../../context/AuthContext";
import {
  ONBOARDING_APPLICATION_STATUS,
  ONBOARDING_USER_STATUS,
} from "../../../utils/constants";
// ga
import { triggerGa, CATEGORY, ACTION } from "../../../utils/gaUtils";

// ----------------------------------------------------------------------

TopNavItem.propTypes = {
  item: PropTypes.object,
};

export default function TopNavItem({ item }) {
  const { label, path, icon, disabled, stepNumber } = item;
  const { user } = useAuth();
  const status = user?.data?.onboarding_application_status;
  const isOnboardingUser = user?.data?.status === ONBOARDING_USER_STATUS;
  const isLocked = status !== ONBOARDING_APPLICATION_STATUS.DRAFT;
  const stepCompleted = user?.data?.current_onboarding_step || 1;
  const { active } = useActiveLink(path);

  const isStepCompleted =
    isOnboardingUser && stepNumber && stepNumber < stepCompleted;

  const isNextStep =
    isOnboardingUser && stepNumber && stepNumber === stepCompleted;

  const isStepDisabled =
    isOnboardingUser && stepNumber && stepNumber > stepCompleted && isLocked;

  const renderIcon = () => {
    if (isOnboardingUser) {
      return (
        <>
          {isStepCompleted ? (
            <CheckCircleIcon
              sx={{
                fontSize: 24,
                color: colors.success500,
              }}
            />
          ) : isNextStep ? (
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: colors.white,
                border: `2px solid ${colors.primary500}`,
                color: colors.primary500,
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {stepNumber}
            </Box>
          ) : (
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "2px solid rgba(255, 255, 255, 0.8)",

                fontSize: "12px",
                fontWeight: "bold",
                opacity: 0.5,
              }}
            >
              {stepNumber}
            </Box>
          )}
        </>
      );
    }

    return icon && <StyledIcon active={active}>{icon}</StyledIcon>;
  };

  const handleClick = () => {
    const page = path?.replace(/^\//, "");
    const screenName = item?.routes?.[0]?.path;
    triggerGa({
      category: CATEGORY.NAVIGATION,
      action: ACTION.BUTTON_CLICK,
      label: label,
      page: page,
      screenName: screenName,
    });
  };
  const renderNavItem = () => (
    <StyledItem active={active} disabled={disabled || isStepDisabled}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {renderIcon()}
        <Typography
          variant="caption"
          sx={{
            color: active ? colors.primary500 : "white",
            textAlign: "center",
            mt: "4px",
            fontWeight: 500,
            fontSize: "10px",
            lineHeight: 1.2,
          }}
        >
          {label}
        </Typography>
      </Box>
    </StyledItem>
  );

  if (isStepDisabled) {
    return <Box data-cy={`nav-item-${label}`}>{renderNavItem()}</Box>;
  }

  return (
    <Link
      component={RouterLink}
      to={path}
      underline="none"
      onClick={handleClick}
      data-cy={`nav-item-${label}`}
    >
      {renderNavItem()}
    </Link>
  );
}
